module.exports = __webpack_public_path__ + "static/media/specular-logo.cca80c5f.svg";